// import "normalize.css";
import "./styles/main.scss";

import { render } from "solid-js/web";
import { Router, Route } from "@solidjs/router";

import App from "./App";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Product from "./pages/Product";

const root = document.getElementById("root") as HTMLElement;

render(
  () => (
    //@ts-ignore
    <Router root={App}>
      <Route path="/" component={Home} />
      <Route path="/cart" component={Cart} />
      <Route path="/checkout" component={Checkout} />
      <Route path="/producten/:category/:name_slug" component={Product} />
      <Route path="*paramName" component={NotFound} />
    </Router>
  ),
  root
);
